function getMapping(position) {
    const map = {
        1 : "x",
        2 : "y",
        3 : "z",
        4 : "k",
        5 : "w",
        6 : "j",
        7 : "t",
        8 : "h"
    }
    return map[position]?.toUpperCase() ?? '';
}

export function getGenericDescWithPlaceholder(desc) {
    return desc.replaceAll('@@H1@@', getMapping(1))
               .replaceAll('@@H2@@', getMapping(2))
               .replaceAll('@@H3@@', getMapping(3))
               .replaceAll('@@H4@@', getMapping(4))
               .replaceAll('@@H5@@', getMapping(5))
               .replaceAll('@@H6@@', getMapping(6))
               .replaceAll('@@H7@@', getMapping(7))
               .replaceAll('@@H8@@', getMapping(8))
               .replaceAll('{{H1}}', getMapping(1))
               .replaceAll('{{H2}}', getMapping(2))
               .replaceAll('{{H3}}', getMapping(3))
               .replaceAll('{{H4}}', getMapping(4))
               .replaceAll('{{H5}}', getMapping(5))
               .replaceAll('{{H6}}', getMapping(6))
               .replaceAll('{{H7}}', getMapping(7))
               .replaceAll('{{H8}}', getMapping(8));
}
